import { SVGAttributes } from "react";

const AgntConnectIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.35343 13.9906C2.02666 15.3173 2.02666 17.4685 3.35343 18.7952C4.6802 20.122 6.83132 20.122 8.15809 18.7952L12.0619 14.8914C13.3887 13.5647 13.3887 11.4136 12.0619 10.0868C11.3444 9.36927 10.3858 9.03979 9.44684 9.09833"
        stroke="#CFB2FF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7644 7.98474C16.0911 6.65797 16.0911 4.50685 14.7644 3.18008C13.4376 1.85331 11.2865 1.85331 9.95971 3.18008L6.05592 7.08387C4.72914 8.41064 4.72915 10.5618 6.05592 11.8885C6.77343 12.606 7.73203 12.9355 8.67096 12.877"
        stroke="#FFA686"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AgntConnectIcon;
